import { useDispatch, useSelector } from "react-redux";
import { fetchTrackOrder, resetTrackOrder } from "../redux/trackOrderSlice";

export default function useTrackOrder() {
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector(
        (state) => state.trackOrder
    );

    const trackOrder = (trackingId) => {
        dispatch(fetchTrackOrder(trackingId));
    };

    const reset = () => {
        dispatch(resetTrackOrder());
    };

    return {
        orderData: data,
        loading,
        error,
        trackOrder,
        reset,
    };
}
